import { render } from "./Strava.vue?vue&type=template&id=f5d7b408&scoped=true"
import script from "./Strava.vue?vue&type=script&lang=js"
export * from "./Strava.vue?vue&type=script&lang=js"

import "./Strava.vue?vue&type=style&index=0&id=f5d7b408&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5d7b408"]])

export default __exports__